
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { IAppForm } from './../IAppForm'
import { ApplicationModule, WizardModule } from '@/store'
import LookupValueDto from '@/types/dto/lookupValueDto'
import EmploymentDto from '../../../types/dto/employmentDto'
import { WizardPage_Enum } from '../../../enums/WizardPage_Enum'

	@Component({
	  name: 'EmploymentForm'
	})
export default class EmploymentForm extends Vue implements IAppForm {
  // #region Props

		@Prop() wizardIndex!: number;

		// #endregion

		// #region Data

		stepIndex = 0;
		prevStepIndex = -1;

		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit', this.wizardIndex)
		}

		validateDetails () {
		  return ((this.$refs.employmentDetails as unknown) as IAppForm).validate()
		}

		validateStatus () {
		  return ((this.$refs.employmentStatus as unknown) as IAppForm).validate()
		}

		validateLength () {
		  return ((this.$refs.employmentLength as unknown) as IAppForm).validate()
		}

		validate () {
		  const detailsValid = this.validateDetails()
		  const statusValid = this.validateStatus()
		  const lengthValid = this.validateLength()

		  if (!detailsValid || !statusValid || !lengthValid) {
		    // slight timeout to allow DOM to update with error classes
		    setTimeout(() => {
		      const err = document.getElementsByClassName('error')
		      if (err.length > 0) {
		        (err[0] as HTMLDivElement).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
		      }
		    }, 1)

		    return false
		  }

		  if (!this.showOccupation) {
		    this.employment.occupation = 'N/A'
		  }

		  if (!this.showName) {
		    this.employment.employerName = 'N/A'
		    this.employment.employerTown = 'N/A'
		  }

		  return true
		}

		next () {
		  switch (this.stepIndex) {
		    case 0:
		      if (!this.validateStatus()) {
		        return
		      }
		      this.prevStepIndex = JSON.parse(JSON.stringify(this.stepIndex))

		      if (!this.showName && !this.showOccupation && this.editingEmploymentIndex > 0) {
		        this.stepIndex += 2
		      } else {
		        this.stepIndex++
		      }

		      break
		    case 1:
		      if (!this.validateDetails()) {
		        return
		      }
		      this.prevStepIndex = JSON.parse(JSON.stringify(this.stepIndex))
		      this.stepIndex++

		      break
		    case 2:
		      if (!this.validateLength()) {
		        return
		      }
		      this.prevStepIndex = -1
		      this.stepIndex = 0

		      this.addEmployment()

		      break
		  }
		}

		editEmployment () {
		  if (!this.validate()) {
		    return false
		  }
		  this.employment.yearsAtEmployer = this.employment.yearsAtEmployer ? this.employment.yearsAtEmployer : 0
		  this.employment.monthsAtEmployer = this.employment.monthsAtEmployer ? this.employment.monthsAtEmployer : 0

		  ApplicationModule.editEmployment(JSON.parse(JSON.stringify(this.employment)))
		  ApplicationModule.updateForm(this.value)

		  ApplicationModule.updateEditingEmploymentIndex()
		  ApplicationModule.updateEditingEmployment(
				{
				  yearsAtEmployer: 0,
				  monthsAtEmployer: 0,
				  employerName: '',
				  employerTown: '',
				  occupation: '',
				  employmentStatusLookup: {
				    id: -1
				  } as LookupValueDto
				} as EmploymentDto
		  )

		  if (WizardModule.callback) {
			this.stepIndex = 0
		    this.$emit('go-to-page', WizardPage_Enum.Summary)
		    WizardModule.updateCallback()
		    return
		  }

		  this.$emit('submit', this.wizardIndex)
		}

		addEmployment () {
		  if (!this.validate()) {
		    return false
		  }

		  const form = ApplicationModule.form
		  form.employments.push(JSON.parse(JSON.stringify(this.employment)))

		  ApplicationModule.updateForm(form)

		  ApplicationModule.updateEditingEmploymentIndex()
		  ApplicationModule.updateEditingEmployment(
				{
				  employmentLevel: form.employments.length,
				  yearsAtEmployer: 0,
				  monthsAtEmployer: 0,
				  employerName: '',
				  employerTown: '',
				  occupation: '',
				  employmentStatusLookup: {
				    id: -1
				  } as LookupValueDto
				} as EmploymentDto
		  )
				
		  if (WizardModule.callback) {
			this.stepIndex = 0
		    this.$emit('go-to-page', WizardPage_Enum.Summary)
		    WizardModule.updateCallback()
		    return
		  }

		  if (this.employmentLength < 12) {
		    this.stepIndex = 0
		    return
		  }

		  this.$emit('submit', this.wizardIndex)
		}

		previous () {
		  // employment in 3 steps
		  if (!this.prePopped && this.stepIndex > 0) {
		    // employment details / net income not needed
		    if (!this.showName && !this.showOccupation && this.editingEmploymentIndex > 0) {
		      // back to employment status
		      this.stepIndex -= 2
		    } else {
		      // back to previous employment step
		      this.stepIndex--
		    }
		    return
		  }
		  // back to summary page
		  if (WizardModule.callback) {
		    ApplicationModule.updateEditingEmploymentIndex()
		    ApplicationModule.updateEditingEmployment(
					{
					  yearsAtEmployer: 0,
					  monthsAtEmployer: 0,
					  employerName: '',
					  employerTown: '',
					  occupation: '',
					  employmentStatusLookup: {
					    id: -1
					  } as LookupValueDto
					} as EmploymentDto
		    )
		    this.$emit('go-to-page', WizardPage_Enum.Summary)
		    WizardModule.updateCallback(false)
		    return
		  }
		  // back to previous page
		  this.$emit('previous')
		}

		clearNA () {
		  this.employment.occupation === 'N/A' ? this.employment.occupation = '' : null
		  this.employment.employerName === 'N/A' ? this.employment.employerName = '' : null
		  this.employment.employerTown === 'N/A' ? this.employment.employerTown = '' : null
		}

		scrollToDetails () {
		  this.clearNA()

		  if (!this.showDetails) {
		    const years = document.getElementById('yearsAtemployer')
		    if (years) {
		      (years as HTMLDivElement).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
		      // allow time to smooth scroll into view before focusing, otherwise jumps to focused element
		      setTimeout(() => {
						document.getElementById('yearsAtemployer')!.focus()
		      }, 300)
		    }
		    return
		  }

		  const details = document.getElementById('empDetails')
		  if (details) {
		    (details as HTMLDivElement).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
		    // allow time to smooth scroll into view before focusing, otherwise jumps to focused element
		    setTimeout(() => {
		      if (this.showOccupation) {
						document.getElementById('occupation')!.focus()
						return
		      }
		      if (this.showName) {
						document.getElementById('employmentName')!.focus()
						return
		      }
		      if (this.showName) {
						document.getElementById('employmentTown')!.focus()
						return
		      }
					document.getElementById('employmentNetIncome')!.focus()
		    }, 300)
		  }
		}
		// #endregion

		// #region Computed

		get value () {
		  return ApplicationModule.form
		}

		get employment () {
		  return ApplicationModule.editingEmployment
		}

		get showNextButton () {
		  return this.stepIndex < 2
		}

		get lengthText () {
		  switch (this.employment.employmentStatusLookup.id) {
		    case 9:
		    case 11:
		    case 14:
		    case 15:
		      return 'How long have you worked here?'
		    case 10:
		      return 'How long have you been Self Employed?'
		    case 12:
		      return 'How long have you been on Disability Living Allowance?'
		    case 13:
		      return 'How long have you been Retired?'
		    case 16:
		      return 'How long have you been a Homemaker?'
		    case 17:
		      return 'How long have you been Unemployed?'
		    case 18:
		      return 'How long have you been in the Armed Forces?'
		    case 19:
		      return 'How long have you been a Student?'
		    case 21:
		      return 'How long have you been a Family Carer?'
		    default:
		      return 'How long has this applied?'
		  }
		}

		get employmentLength () {
		  let count = 0

		  this.value.employments.forEach(e => {
		    count += e.monthsAtEmployer ? Number(e.monthsAtEmployer) : 0
		    count += e.yearsAtEmployer ? (Number(e.yearsAtEmployer) * 12) : 0
		  })

		  count += Number(this.employment.yearsAtEmployer ? this.employment.yearsAtEmployer * 12 : 0)
		  count += Number(this.employment.monthsAtEmployer)

		  return count
		}

		get showDetails () {
		  return !((!this.showOccupation && !this.showName) && this.employment.employmentLevel > 0)
		}

		get lengthRemaining () {
		  const remaining = 12 - this.employmentLength
		  const years = Math.floor(remaining / 12)
		  const months = remaining % 12

		  let str = ''

		  str += years === 0 ? '' : years > 1 ? years + ' years ' : years + ' year '
		  str += months === 0 ? '' : months > 1 ? months + ' months' : months + ' month'

		  return str
		}

		get isNew () {
		  return ApplicationModule.isNewEmployment
		}

		get editingEmploymentIndex () {
		  return ApplicationModule.editingEmploymentIndex ?? -1
		}

		get prePopped () {
		  return ApplicationModule.isPrePopped
		}

		get showOccupation () {
		  return this.employment.employmentStatusLookup.id === 9 ||
				this.employment.employmentStatusLookup.id === 11 ||
				this.employment.employmentStatusLookup.id === 10 ||
				this.employment.employmentStatusLookup.id === 14 ||
				this.employment.employmentStatusLookup.id === 15 ||
				this.employment.employmentStatusLookup.id === 18
		}

		get showName () {
		  return this.employment.employmentStatusLookup.id === 9 ||
				this.employment.employmentStatusLookup.id === 11 ||
				this.employment.employmentStatusLookup.id === 14 ||
				this.employment.employmentStatusLookup.id === 15
		}

  // #endregion
}
